import React, {
    useCallback, useContext, useEffect, useState
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {ViewModelForm, ViewModelServiceContext} from 'gw-portals-viewmodel-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {useAuthentication} from 'gw-digital-auth-react';
import {TranslatorContext} from "@jutro/locale";
import {useDependencies} from "gw-portals-dependency-react";
import metadata from './AutomaticPayments.metadata.json5';
import messages from './AutomaticPayments.messages';
import styles from './AutomaticPayments.module.scss';
import GatewayBillingService from "../../../capabilities/nexus-capability-billing/services/GatewayBillingService";
import {ModalNextProvider} from "@jutro/components";
import {messages as commonMessages} from "gw-platform-translations";
import InstitutionDetails
    from '../../gw-capability-common-components/EFTComponent/InstitutionDetails';

const PAYMENT_METHOD_ERRORS = {
    bankAccountNoInvalid: 'bankAccountNoInvalid',
    paymentMethodSaveFailed: 'paymentMethodSaveFailed',
    paymentMethodSaveSuccess: 'paymentMethodSaveSuccess',
    fieldEmpty: 'fieldEmpty'
};

function AutomaticPayments(props) {
    const { existingPaymentGroupInfo, baseProvnce } = props;
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const [paymentInstrumentInfo, setPaymentInstrumentInfo] = useState(existingPaymentGroupInfo);
    const [paymentMehtodStatus, setPaymentMehtodStatus] = useState();
    const [paymentMehtodCCStatus, setPaymentMehtodCCStatus] = useState();
    const [paymentMehtod, setPaymentMethod] = useState(null);
    const viewModelService = useContext(ViewModelServiceContext);
    const { AccountBillingDetailsService, BillingService } = useDependencies(
        ['AccountBillingDetailsService', 'BillingService']
    );
    let isMonerisSubmitted = false;
    const [monURL, updateMonURL] = useState('');
    const [iframeUrl, updateiFrameUrl] = useState('');
    const [loadIframeUrl, updateLoadIframeUrl] = useState(false);
    const [addCreditCardInstrument, updateAddCreditCardInstrument] = useState(false);
    const [availablePaymentOptions, setAvailablePaymentOptions] = useState([]);
    const [institutionDetails, setInstitutionDetails] = useState([]);
	const [selectedInstitutionValue, updateInstitutionValue] = useState('');
    const [selectedInstitutionNameValue, updateInstitutionNameValue] = useState('');

    const initializePaymentModel = () => {
        return {
            paymentMethod: 'ach',
            RequestSource: 'CEPortal',
            bankAccountData: {},
            creditCardData: {}
        };
    };

    const [paymentInstrumentModel, setPaymentInstrumentModel] = useState(initializePaymentModel());
    const initializeVM = () => {
        return viewModelService.create(
            paymentInstrumentModel,
            'bc',
            'edge.capabilities.billing.dto.PaymentInstrumentDTO'
        );
    };
    let paymentInstrumentVM = initializeVM();

    const isAutomaticPaymentEnabled = () => {
        return paymentInstrumentInfo && paymentInstrumentInfo.paymentInstrument && paymentInstrumentInfo.paymentInstrument.paymentMethod !== 'responsive';
    };

    const loadInvoiceStreamDetailsByStreamId = useCallback(
        () => {
            if(existingPaymentGroupInfo.internalId) {
            AccountBillingDetailsService.getUserInvoiceStreamDetails_EY(
                existingPaymentGroupInfo.internalId,
                authHeader
            ).then((response) => {
                setPaymentInstrumentInfo(response);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.failToLoadInvoiceDetails,
                    message: messages.sorryWeCanNotLoadYourPolicyInformationAtThisTime,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).then(() => {
                    // history.push('/home');
                }, _.noop);
            });
          }
        },
        [AccountBillingDetailsService, authHeader, existingPaymentGroupInfo]
    );

    useEffect(() => {
        if (baseProvnce === 'NS' || (paymentInstrumentInfo && paymentInstrumentInfo.paymentPlan === 'Monthly Plan')) {
            setAvailablePaymentOptions([
                {
                    code: 'ach',
                    displayName: messages.bankAccount
                }
            ]);
        } else {
            setAvailablePaymentOptions([
                {
                    code: 'ach',
                    displayName: messages.bankAccount
                },
                {
                    code: 'preauthorizedCC_EY',
                    displayName: messages.creditCard
                }
            ]);
        }
    }, [baseProvnce, paymentInstrumentInfo, setAvailablePaymentOptions]);

    useEffect(() => {
        setPaymentInstrumentInfo(existingPaymentGroupInfo);
    }, [existingPaymentGroupInfo]);

    useEffect(() => {
        if (isAutomaticPaymentEnabled()) {
           // loadInvoiceStreamDetailsByStreamId();
        }
    }, [existingPaymentGroupInfo]);

    const initDefaults = () => {
        loadInvoiceStreamDetailsByStreamId();
        setPaymentInstrumentModel(initializePaymentModel());
        paymentInstrumentVM = initializeVM();
        setPaymentMethod('');
    }

    const savePaymentMethod = useCallback(
        // eslint-disable-next-line consistent-return
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }
            if (_.get(paymentInstrumentVM.value, 'paymentMethod') === 'ach') {
                const bankAccountNumber = _.get(paymentInstrumentVM.value, 'bankAccountData.bankAccountNumber');
				_.set(paymentInstrumentVM.bankAccountData, 'bankAccountType.value', paymentInstrumentVM?.bankAccountData?.bankAccountType?.aspects?.availableValues[0]?.code);

                if (!paymentInstrumentVM.bankAccountData.aspects.subtreeValid) {
                    setPaymentMehtodStatus(PAYMENT_METHOD_ERRORS.fieldEmpty);
                    return Promise.resolve();
                }

                if (!(/^\d{7,12}$/.test(bankAccountNumber))) {
                    setPaymentMehtodStatus(PAYMENT_METHOD_ERRORS.bankAccountNoInvalid);
                    return Promise.resolve();
                }
            }

            GatewayBillingService.setPaymentGroupPaymentInformation(
                paymentInstrumentInfo.accountNumber,
                paymentInstrumentInfo.internalId,
                paymentInstrumentVM.value,
                authHeader
            ).then((resp) => {
                console.log(resp);
                setPaymentMehtodStatus(PAYMENT_METHOD_ERRORS.paymentMethodSaveSuccess);
                initDefaults();
            }).catch((error) => {
                console.log(error);
                setPaymentMehtodStatus(PAYMENT_METHOD_ERRORS.paymentMethodSaveFailed);
            });
        },
        [GatewayBillingService, authHeader, paymentInstrumentModel, paymentMehtodStatus]
    );

    const writeValue = useCallback(
        (value, path) => {
            _.set(paymentInstrumentVM.value, path, value);
            setPaymentInstrumentModel(paymentInstrumentVM.value);
        },
        [paymentInstrumentModel]
    );

    const showInstituteDetailsOnModal = useCallback((response) => {
        const componentProps = {
            institutionDetails: response
        };
        ModalNextProvider.showModal(
            <InstitutionDetails {...componentProps} />
        ).then((selectedInstituteEntry) => {
            if (!_.isEmpty(selectedInstituteEntry)) {
                _.set(paymentInstrumentVM.value, 'bankAccountData.instituteName_EY', selectedInstituteEntry.bankName);
                _.set(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY', selectedInstituteEntry.institutionNumber);
                setPaymentInstrumentModel(paymentInstrumentVM.value);
                paymentInstrumentVM = initializeVM();
               /* writeValue(selectedInstituteEntry.bankName, 'bankAccountData.instituteName_EY');
                writeValue(selectedInstituteEntry.institutionNumber, 'bankAccountData.instituteNumber_EY');*/
            }
        });
    }, [ModalNextProvider, paymentInstrumentModel, paymentInstrumentVM]);

    async function findInstitutionDetails (textInput) { 
        let dataArray = [];
        if (textInput === undefined ) {
            return dataArray;
        }      
        await GatewayBillingService.searchBankInstitute_EY(_.get(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY'), null, authHeader)
        .then((response) => {
            let originalValue = [];
            response.forEach((instituteInfo, index) => {
                    dataArray = [...dataArray, {id: index, displayName: `${instituteInfo.institutionNumber} - ${instituteInfo.bankName}`
                }];
                originalValue[index] = instituteInfo;
            });
            setInstitutionDetails(originalValue);
            //showInstituteDetailsOnModal(response);
        });
        return dataArray;
    }
	
	const handleInstitutionDetails = (value) => {
        if (value) {
            let institution = institutionDetails[value.id];
            // _.set(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY', institution.institutionNumber);
            // _.set(paymentInstrumentVM.value, 'bankAccountData.instituteName_EY', institution.bankName);
            writeValue(institution.bankName, 'bankAccountData.instituteName_EY');
            writeValue(institution.institutionNumber, 'bankAccountData.instituteNumber_EY');
        }
        updateInstitutionValue(value);
    };

    const ordinalSuffixOf = (i) => {
        const j = i % 10;
        const k = i % 100;
        if (j === 1 && k !== 11) {
            return `${i}st`;
        }
        if (j === 2 && k !== 12) {
            return `${i}nd`;
        }
        if (j === 3 && k !== 13) {
            return `${i}rd`;
        }
        return `${i}th`;
    };

    const getPaymentCycleMessage = () => {
        if (isAutomaticPaymentEnabled()) {
            const day = ordinalSuffixOf(paymentInstrumentInfo.paymentInstrument.overrideDayOfMonth);
            let month = 1;
            switch (paymentInstrumentInfo.paymentPlan) {
                case 'Two Pay Plan':
                    month = 2;
                    break;
                case 'Three Pay Plan':
                    month = 3;
                    break;
                case 'Monthly Plan':
                    month = 12;
                    break;
                default:
                    return translator(messages.paymentCycleUpdatedMessageForMonths, { day: day, month: month });
            }
            return translator(messages.paymentCycleUpdatedMessageForMonths, { day: day, month: month });
        }
        return '';
    };

    const addCreditCardPaymentInstrument = useCallback(
        // eslint-disable-next-line consistent-return
        (evt) => {
            /*if (evt) {
                evt.preventDefault();
            }
*/
            paymentInstrumentVM.value.bankAccountData = null;
            GatewayBillingService.setPaymentGroupPaymentInformation(
                paymentInstrumentInfo.accountNumber,
                paymentInstrumentInfo.internalId,
                paymentInstrumentVM.value,
                authHeader
            ).then((resp) => {
                console.log(resp);
                setPaymentMehtodStatus(PAYMENT_METHOD_ERRORS.paymentMethodSaveSuccess);
                initDefaults();
            }).catch((error) => {
                console.log(error);
                setPaymentMehtodCCStatus(PAYMENT_METHOD_ERRORS.paymentMethodSaveFailed);
                ModalNextProvider.showAlert({
                    title: messages.creditCardError,
                    message: messages.billingMethodChangeError,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
        },
        [GatewayBillingService, authHeader, paymentInstrumentModel, paymentInstrumentVM, paymentMehtodStatus]
    );

    /**Function called at iFrame response */
    var respMsg = function(e) {
        if (!(paymentInstrumentVM.creditCardData.aspects.valid && paymentInstrumentVM.creditCardData.aspects.subtreeValid)) {
            return;
        }
        if(!isMonerisSubmitted) {
            return;
        }
        isMonerisSubmitted = false;
        var respData = eval("(" + e.data + ")");
        // updateCardError('');
        // updateToken('');
        if(respData.responseCode=='001'){
            /**Todo change below to scope hide and show */
            /*document.getElementById("validateButton").style.display = 'none';
            document.getElementById("monerisFrame").style.display = 'none';*/
            updateLoadIframeUrl(false);
            updateAddCreditCardInstrument(false);
            //updateToken(respData.dataKey);
            paymentInstrumentVM.creditCardData.token_EY.value = respData.dataKey;
            updateAddCreditCardInstrument(false);
            // $scope.token = 'ot-Y70epLUoSub5puf3HQ9nYXsK5';
            // submissionVM.bindData.paymentDetails.creditCardData.token_EY.value = token;
            addCreditCardPaymentInstrument();
        }
       /* paymentInstrumentVM.creditCardData.token_EY.value = "ot-Hq89rf3fHVA3cJBOWYpoVoPR0";
        addCreditCardPaymentInstrument();*/
        console.log(`payment gateway response: ${respData.errorMessage}`);
        var errorDesc = "";
        for (var i = 0; i < respData.responseCode.length; i++) {
            if (respData.responseCode[i] != "") {
                switch(respData.responseCode[i]) {
                    case "940":
                    case "941":
                    case "942":
                        errorDesc = errorDesc + "Validation failed. Please retry after checking the card details";
                        break;
                    case "943":
                        errorDesc = errorDesc + "Card Number is invalid";
                        break;
                    case "944":
                        errorDesc = errorDesc + "Invalid expiration date (mmyy, must be current month or in the future)";
                        break;
                    case "945":
                        errorDesc = errorDesc + "Invalid CVV data (not 3 digits)";
                        break;
                    default:
                }
                if (respData.responseCode.length > 1) {
                    errorDesc = errorDesc + " ; "	;
                }
                if (respData.responseCode.length >= 1 && errorDesc != "") {
                    updateAddCreditCardInstrument(false);
                    ModalNextProvider.showAlert({
                        title: messages.creditCardError,
                        message: errorDesc,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            }
        }
        /**Todo display error in popup, add hide and show */
        // $scope.cardError = errorDesc;
        // $scope.token = respData.dataKey;
    };

    /**Get iFrame URL */
    const getIframeUrl  = () => {
        updateLoadIframeUrl(false);
         var modeOfPayment = paymentInstrumentVM.creditCardData.modeOfReceiving_EY.value
        && paymentInstrumentVM.creditCardData.modeOfReceiving_EY.value.code ? paymentInstrumentVM.creditCardData.modeOfReceiving_EY.value.code : 'spokenoverphone'
        BillingService.getMonerisRequestURL(modeOfPayment, authHeader).then(paymentUrl_EY => {
            updateiFrameUrl(paymentUrl_EY);
            const index = paymentUrl_EY.indexOf('?');
            updateMonURL(paymentUrl_EY.substring(0, index));
            updateLoadIframeUrl(true);
            updateAddCreditCardInstrument(true);
        }).catch(() => {
            ModalNextProvider.showAlert({
                title: messages.paymentStatus,
                message: messages.paymentAddFailure,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            updateLoadIframeUrl(false);
            updateAddCreditCardInstrument(false);
            updateiFrameUrl('');
        });
    };

    /**Validate card */
    const doMonerisSubmit = () => {
        if (!(paymentInstrumentVM.creditCardData.aspects.valid && paymentInstrumentVM.creditCardData.aspects.subtreeValid)) {
            ModalNextProvider.showAlert({
                title: messages.creditCardError,
                message: messages.creditCardEmptyError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return;
        }
        isMonerisSubmitted = true;
        var monFrameRef = document.getElementById('monerisFrame').contentWindow;
        // monFrameRef.postMessage('tokenize','https://esqa.moneris.com/HPPtoken/index.php');
        monFrameRef.postMessage('tokenize', monURL);
        if (window.addEventListener)
        {
            window.addEventListener ("message", respMsg, false);
        }
        else
        {
            if (window.attachEvent)
            {
                window.attachEvent("onmessage", respMsg);
            }
        }
        return false;
    };

    /*const addPaymentInstrument = () => {
        getIframeUrl();
        updateAddCreditCardInstrument(true);
    };*/

    const renderCreditCardTableTable = () => {
        const noRecordsMessage = 'No records found';
        return (
            <>
                <div>
                    <iframe
                        id="monerisFrame"
                        title="moneris payment"

                        frameBorder="0"
                        allowFullScreen
                        width="100%"
                        height="100%"
                        //src="https://www.youtube.com"
                        src={iframeUrl}
                        //src="https://esqa.moneris.com/HPPtoken/index.php?id=htB4HNFH85X9F7S&pmmsg=true&css_body=background:white;&css_textbox=border-width:2px;margin-bottom:10px;&css_textbox_pan=width:140px;&css_input_label=float:left;padding-right:10px;width:200px;&pan_label=Credit Card Number&exp_label=Expiry Date(MMYY)&&enable_exp=1&css_textbox_exp=width:40px;&display_labels=1"
                    />
                </div>
            </>
        );
    };

    /*const handleCreditCardModeChange = useCallback(
        (value) => {
            writeValue(value, 'creditCardData.modeOfReceiving_EY');
            getIframeUrl();
            updateAddCreditCardInstrument(true);
        },
        [paymentInstrumentModel]
    );*/

    const handlePaymentOptions = (data) => {
        writeValue(data, 'paymentMethod');
        writeValue({}, 'creditCardData');
        writeValue({}, 'bankAccountData');
        setPaymentMethod('');
    };

    const showBankOrCCPaymentMethod = () => {
        if (_.get(paymentInstrumentVM.value, 'paymentMethod') === 'ach') {
            writeValue({ isValidationRequired: true }, 'bankAccountData');
            writeValue(null, 'creditCardData');
            updateInstitutionValue('');
        }

        if (_.get(paymentInstrumentVM.value, 'paymentMethod') === 'preauthorizedCC_EY') {
            getIframeUrl();
            updateAddCreditCardInstrument(true);
            writeValue({ modeOfReceiving_EY: 'spokenoverphone' }, 'creditCardData');
            writeValue(null, 'bankAccountData');
        }
        writeValue(paymentInstrumentInfo.paymentInstrument.overrideDayOfMonth, 'overrideDayOfMonth');
        setPaymentMethod(_.get(paymentInstrumentVM.value, 'paymentMethod'));
        setPaymentMehtodStatus(null);
    };

    const setInstitutionName = () => { 
        if (selectedInstitutionValue === null) {
            writeValue('-', 'bankAccountData.instituteName_EY');
            writeValue('', 'bankAccountData.instituteNumber_EY');
        }
    }

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        paymentMethodNotAvailable: {
            visible: !isAutomaticPaymentEnabled()
        },
        automaticPaymentsContainer: {
            visible: isAutomaticPaymentEnabled()
        },
        paymentMethodDetails: {
            visible: isAutomaticPaymentEnabled()
        },
        paymentMethodName: {
            content: isAutomaticPaymentEnabled() ? paymentInstrumentInfo.paymentInstrument.displayName : ''
        },
        paymentCycle: {
            content: getPaymentCycleMessage()
        },
        /*selectPaymentOptions: {
            availableValues: availablePaymentOptions,
            value: _.get(paymentInstrumentVM.value, 'paymentMethod')
        },*/
        paymentMethodErrorMessageContainer: {
            visible:
                !_.isEmpty(paymentMehtodStatus)
                && paymentMehtodStatus !== PAYMENT_METHOD_ERRORS.paymentMethodSaveSuccess
        },
        paymentMethodErrorMessage: {
            message: translator(messages[paymentMehtodStatus])
        },
        bankAccountFormContainer: {
            visible: paymentMehtod === 'ach'
        },
        bankButtonAndErrorMessageContainer: {
            visible: paymentMehtod === 'ach'
        },
        creditCardFormContainer: {
            visible: paymentMehtod === 'preauthorizedCC_EY'
        },
        creditCardPayment: {
            content: renderCreditCardTableTable(),
            visible: loadIframeUrl
        },
        buttonAndValidationContainer: {
            visible: !_.isEmpty(paymentMehtod)
        },
        paymentMethodSuccessMessage: {
            visible: paymentMehtodStatus === PAYMENT_METHOD_ERRORS.paymentMethodSaveSuccess
        },
		instituteNumber: {
            availableValues: institutionDetails,
            //value: _.get(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY')
            value: selectedInstitutionValue
        }
        /* brokerNote: {
            visible: isAutomaticPaymentEnabled()
        } */
    };

    const resolvers = {
        resolveCallbackMap: {
            handlePaymentOptions: handlePaymentOptions,
            showBankOrCCPaymentMethod,
            savePaymentMethod,
            doMonerisSubmit,
            findInstitutionDetails,
			handleInstitutionDetails,
            setInstitutionName
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (elementId, path) => {
            return readViewModelValue(metadata.componentContent, paymentInstrumentVM, elementId, path, overrideProps);
        },
        [paymentInstrumentModel, overrideProps]
    );

    const updatModel = useCallback(
        (elementId, path) => {
            return readViewModelValue(metadata.componentContent, paymentInstrumentVM, elementId, path, overrideProps);
        },
        [paymentInstrumentVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={paymentInstrumentVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onModelChange={updatModel}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

AutomaticPayments.propTypes = {
    existingPaymentGroupInfo: PropTypes.object,
    baseProvnce: PropTypes.string
};

export default AutomaticPayments;
